import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * Hook to handle edit mode session with mock users
 * Checks sessionStorage for edit mode and mock user data
 * Temporarily switches the active user if in edit mode
 */
export const useEditModeSession = () => {
  const { user, setTempUser } = useAuth();
  const [originalUser, setOriginalUser] = useState(null);

  useEffect(() => {
    const isEditMode = sessionStorage.getItem("editMode") === "true";
    const editModeUserStr = sessionStorage.getItem("editModeUser");

    if (isEditMode && editModeUserStr) {
      try {
        const mockUser = JSON.parse(editModeUserStr);

        // Store original user to restore later
        if (user && !originalUser) {
          setOriginalUser(user);
        }

        // Switch to mock user if method exists
        if (setTempUser) {
          setTempUser(mockUser);
        }

        // Cleanup on unmount or when edit mode is disabled
        return () => {
          const stillInEditMode = sessionStorage.getItem("editMode") === "true";
          if (!stillInEditMode && originalUser && setTempUser) {
            setTempUser(originalUser);
          }
        };
      } catch (err) {
        console.error("Failed to parse mock user:", err);
      }
    }
  }, [user, originalUser, setTempUser]);

  return {
    isInEditMode: sessionStorage.getItem("editMode") === "true",
  };
};
